import React from 'react';
import { Typography, Card, Popover } from 'antd';
import styles from './Faq.module.scss';
import foreclosure from 'assets/img/foreclosure.png';
import surrogate from 'assets/img/surrogate.png';
import condemnation from 'assets/img/CONDEMNATION.png';

const Faq: React.FC = () => {
  return (
    <Card>
      <Typography>
        <table>
          <tbody>
            <tr>
              <td className={styles.bold}>What was the Mennonite decision?</td>
            </tr>
            <tr>
              <td>
                The court declared that all parties with an interest in the real
                estate must be notified of an In Rem proceeding from 1976 to
                date. We must show all mortgages as to enable the client to make
                sure the mortgagees were served with notice of the In Rem action
                so as to cut off their interest in the property.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What year is the cut-off date for mortgages on a parcel with an
                In Rem foreclosure due to the Mennonite decision ?
              </td>
            </tr>
            <tr>
              <td>
                You must show all mortgages beginning with the In Rem deed
                recorded in 1976.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What determines if we should run a lending institution that has
                been in title for judgments and liens ?
              </td>
            </tr>
            <tr>
              <td>
                Run all lending institutions except for federal agencies, such
                as Federal National Mortgage Association, Federal Home Loan
                Mortgage Agency, etc.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Assume you have an open mortgage on an examination taken by an
                owner of the parcel some twenty years ago – they have since
                conveyed out, and would not fall into the ten-year period which
                is searched; do we still run that individual for judgments as a
                result of that open mortgage, or are they now moot because the
                party has not been in title for over ten years?
              </td>
            </tr>
            <tr>
              <td>
                We must show the mortgage, however only run the parties in title
                for the last ten years.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Do we need to indicate the type of deed being abstracted – i.e.
                Bargain and Sale, Quitclaim, Warranty, etc.?
              </td>
            </tr>
            <tr>
              <td>Yes, always</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Condemnations and Land Dispositions – do these definitively cut
                off Covenants and Restrictions prior, or are there exceptions?
                If so, what are the exceptions?
              </td>
            </tr>
            <tr>
              <td>
                No, they do not cut off any C&amp;R’s – always turn them out
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                If you have a Lis Pendens but the mortgage being foreclosed is
                satisfied, do you show the LP ?
              </td>
            </tr>
            <tr>
              <td>
                Yes, show the LP and clerk’s minutes and put a comment that the
                mortgage is satisfied with the recording info of the sat.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When you are running a name and you find a judgment over 10
                years old, should you show it ?
              </td>
            </tr>
            <tr>
              <td>
                No, as long as it is not extended or renewed – ALWAYS check the
                remarks. Keep iin mind that federal judgments are good for 20
                years and are filed in the same index as federal tax liens.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How far back do we turn out welfare liens for ?
              </td>
            </tr>
            <tr>
              <td>
                If the lien is filed within the mortgage index it is good
                forever. If it is filed within the judgment index it is good for
                10 years.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                For consideration amount on deeds, do you really want us to put
                the standard verbiage on deeds if they show no amount as $10.00
                or $1.00 ? For example if transfer tax is 495.00 and deed says
                $10.00 ?
              </td>
            </tr>
            <tr>
              <td>
                If the actual consideration (sales price) is stated then show
                it. If not then put the consideration stated on the deed.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What is negative amortization in a mortgage ?
              </td>
            </tr>
            <tr>
              <td>
                Negative amortization is a mortgage that has a fixed or maximum
                monthly payment – therefore if the interest rate rises then the
                amount due is more that the monthly payment. This cause the
                excess interest to be added to the principal. You must show BOTH
                the face amount and the maximum amount of the mortgage.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What do we as a company take as closing off a foreclosure
                action? I was taught that an lis pendens is good for three years
                from the last court minutes. I have been taught that if it goes
                to judgment of foreclosure, this extends it and makes it a valid
                LP for 10 years. Can we take just a stipulation of
                discontinuance as cutting off the lp? What about if the judgment
                of fcl is cancelled? The action itself is still good?
              </td>
            </tr>
            <tr>
              <td>
                By statute, a lis pendens is good for three years, unless it is
                extended. If it goes to judgment of foreclosure, the judgment is
                effective for 6 years. If a stipulation of discontinuance of the
                action, there should still be filed a stipulation discontinuing
                the lis pendens. Both the Lis Pendens AND the clerk’s minutes
                need to indicate a cancellation. If the correct procedure is not
                followed, show the lis pendens and clerk’s minutes and put
                comments. If the lis pendens in a foreclosure action is over 3
                years old and there is no judgment of foreclosure and no other
                current activity on the clerk’s minutes, then it is not
                necessary to show the lis pendens. Remember to ALWAYS turn out a
                lis pendens by a governmental agency FOREVER.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When we have a dysfunctional satisfaction, I have the examiners
                turn everything out on the abstract sheet with a copy of the sat
                as an fyi. Do I need to do this if the sat amount is correct but
                they don’t list both liber and pages of a consolidation?
              </td>
            </tr>
            <tr>
              <td>
                A good satisfaction must list every mortgage being satisfied,
                not only the consolidation. If the satisfaction is defective you
                must abstract all of the mortgages AND provide a copy of the sat
                AND add a comment. List all of the mortgages as open on your
                certification sheet.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>What is a stub search ?</td>
            </tr>
            <tr>
              <td>
                A stub search is basically another name for an attorney search,
                an LML, a second mortgage search, a short, a refi – different
                locales use different labels.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Whenever I abstract a foreclosure action and it goes to sale,
                where in the file would you find the question pertaining to the
                date of notice of sale served?
              </td>
            </tr>
            <tr>
              <td>
                The notice of sale is published in a newspaper and you would
                find the affidavit of publication in the file. You will also
                find an affidavit of service of the notice of sale.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                In rare cases I find a deed from the Bankruptcy Court. Does this
                deed take care of open mortgages and other liens that precede
                this deed?{' '}
              </td>
            </tr>
            <tr>
              <td>
                Although the bankruptcy action may wipe out mortgages and liens,
                you must show them since without examining the bankruptcy action
                you are unable to determine if the liens are cut off. This
                should be left for the reader to decide.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How long are Federal Tax Liens good for ?
              </td>
            </tr>
            <tr>
              <td>10 years unless extended or refilled</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                For how many years do we show Federal judgments ?
              </td>
            </tr>
            <tr>
              <td>
                Federal judgments are good for 20 years and are filed in the
                same index as federal tax liens.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>How long are UCC’s good for ?</td>
            </tr>
            <tr>
              <td>
                UCC’s are good for 5 years and must be continued within that
                time. UCC’s on a co-op apartment do not expire and should be
                shown forever.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                If you are running the last name Williamson, should you show a
                return on Williamsen ?
              </td>
            </tr>
            <tr>
              <td>
                ABSOLUTELY – this could be a typo – we should show anything
                within reason to prevent claims.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How would you search the name “Marie St. Fleur” ?
              </td>
            </tr>
            <tr>
              <td>
                You should search: St. Fleur, Ma - Saint Fleur, Ma - Fleur, Ma
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What variations should be taken when running names ?
              </td>
            </tr>
            <tr>
              <td>
                We must show anything the person conceivably could be called –
                different spelling should ALWAYS be taken as should any possible
                nicknames – play it safe, when in doubt – turn it out.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What is the proper way to search a name ?
              </td>
            </tr>
            <tr>
              <td>
                When running names, you should only put in a few letters of the
                last name and the first two letters of the first name. If it is
                a VERY common last name then it is permissible to put in more
                letters of the last name. Turn out any judgment vs the person,
                within reason, that the debtor may be called – if you are
                searching “Rob” you would show: Robert, Rob, Robby, Roberto,
                Robin, etc. When you are running a corporation or other entity,
                you should only input the complete first word and the only the
                first letter of the second work of the entity, at the most. Be
                careful to not spell out any word that could be abbreviated –
                such as “manufacturing” might be inputed as “mfg” by the clerk.
                Our job is to find any lien that may affect the debtor – the
                less we input, the more we can find.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How should Asian names be searched ?
              </td>
            </tr>
            <tr>
              <td>
                If you are searching “Ho Tse Wong” you should search all
                possible variations:
                <br />
                Wong, Ho - Wong, Ts - Ho, Ts - Ho, Wo - Tse, Ho - Tse,Wo
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                If there is a mortgage foreclosure that goes to judgment, but
                then the mortgage is satisfied, do we still need to show the
                action ?
              </td>
            </tr>
            <tr>
              <td>
                The judgment of foreclosure should still be vacated and the
                action cancelled. If it is not then show the lis pendens and the
                clerk’s minutes and comment that the mortgage is satisfied.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                A Lis Pendens is valid for 3 years. If the mortgage is still
                open after the 3 years has expired, do we give a copy of the lis
                pendens ?
              </td>
            </tr>
            <tr>
              <td>
                A Lis Pendens is good for 3 years unless it is extended or
                refilled. As long as the LP has not gone to judgment, it is not
                necessary to show the lis pendens after the 3 years has expired.
                It should be noted that you should always use some common sense
                – if the 3 years was up yesterday, then you might want to turn
                it out.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Do you run trustees as a corporation or as an individual{' '}
              </td>
            </tr>
            <tr>
              <td>
                {' '}
                If running “Trustees of the estate of John Doe” then run as
                corporation. If running “Mary Roe, trustee” then run as
                individual. You should play it safe and run it both ways.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                On a refi must you always give a 24 monthy deed chain, even if
                the only deed within the 24 months was insured by a title
                company ?
              </td>
            </tr>
            <tr>
              <td>
                Yes, you must always start your deed chain with a deed that is
                at least 24 months old and that is not family to family. In
                addition, you must run all names beginning with the grantee in
                the oldest deed. Note that on an LML or an ATT it is NOT
                necessary to give a 24 month chain – just start with a bonafide
                deed (not family to family).
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When you search a name, what is the period that you search it
                for ?
              </td>
            </tr>
            <tr>
              <td>
                All names are searched from 10 years ago until they conveyed
                out. If they conveyed to a family member or to someone for no
                consideration or nominal consideration then you must search the
                name until the family conveys out. People sell to family members
                thinking they can avoid a judgment – we must make sure this does
                not happen.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                On tax lien foreclosures if the tax lien being foreclosed
                precedes 2 tax liens do those specific tax liens always get
                turned up on the search even though the city of New York is a
                party defendant?
              </td>
            </tr>
            <tr>
              <td>
                Yes, tax liens cannot get cut off – all tax liens must always be
                shown as should all mortgages.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>Who has rights in an alleyway ?</td>
            </tr>
            <tr>
              <td>
                To determine who has rights in an alleyway we must locate the
                agreement or declaration that created said alleyway. At times
                the alleyway or easement can be created by a common owner by
                reference in the deeds as he sells off each piece of property
                that has an interest in the alleyway.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>What are air rights ?</td>
            </tr>
            <tr>
              <td>
                Air rights refers to the interest in the air space of a parcel
                of land. The fee owner owns the land “up to the heavens” – but
                he may sell them to another party or grant an easement over the
                air rights.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Should I show a mortgage on the air rights of the property I am
                searching ?
              </td>
            </tr>
            <tr>
              <td>
                Yes, unless you are specifically asked not to search the air
                rights parcel OR if your air rights have been conveyed to
                another bonafide party.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>What is a condemnation ?</td>
            </tr>
            <tr>
              <td>
                A condemnation is an action by which the sovereign (the
                government) uses the concept of eminent domain to acquire a
                piece of land that is determined to be in the government’s best
                interests.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How long are Notices of Lending good for ?
              </td>
            </tr>
            <tr>
              <td>Forever</td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How important are sidewalk violations from the 1960’s ?
              </td>
            </tr>
            <tr>
              <td>
                Sidewalk Violations do not expire and are therefore still a
                lien.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How should I certify a Regulatory Agreement ?
              </td>
            </tr>
            <tr>
              <td>
                Regulatory Agreements should be listed with your mortgage
                documents.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When there is more than 1 extension agreement, which one do I
                show ?
              </td>
            </tr>
            <tr>
              <td>
                It is only necessary to show the LAST extension agreement,
                however you must show ALL consolidation agreements.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                On a short search, if the grantor on the deed or record is the
                surviving tenant, spouse, etc. of a deceased person, (assuming
                no prior deeds are needed) does that person need to be ran for
                surrogates?{' '}
              </td>
            </tr>
            <tr>
              <td>
                No, as long as that deed is considered a good starting point.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                On a short search, if you are only turning out one deed in your
                title and it happens to be an executor’s deed with full
                consideration, can u stop there?{' '}
              </td>
            </tr>
            <tr>
              <td>
                Yes, as long as it is not family to family and is at least 24
                months old.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                On a short search, do individual mortgagees need to be ran for
                surrogates? What is the reason? Individual mortgagees don’t
                necessarily have to live in that county.
              </td>
            </tr>
            <tr>
              <td>
                Yes, individual mortgagees need to be run in surrogates – if
                they are deceased that will show who needs to be contacted to
                satisfy the mortgage and sign the satisfaction. This is one
                reason why it is important to list the mortgagee’s address – the
                client will know where to search Surrogate’s Court.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When running names, if you have to turn out JOSEPH RODRIGUEZ for
                JOSE RODRIGUEZ as a variation, would I also turn out MARY for
                MARIA, PETER for PEDRO, LOUIS for LUIS, etc…?
              </td>
            </tr>
            <tr>
              <td>
                Usually yes – on a very common name such as Rodriguez it is ok
                to take less variation BUT in these rare occurrences you must
                specifically state: “Did not take Joseph” (if running Jose)
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                If a lis pendens to foreclose a mechanics lien is put on prior
                to a mechanic lien’s expiration (other than the intended
                foreclosed ml), does that extend all the other mechanics liens
                that are active in the time period?{' '}
              </td>
            </tr>
            <tr>
              <td>
                Yes – any LP extends all mechanic’s liens that are still
                effective at the time of the LP filing.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                If a deed into the current owners is recent, do we still run
                surrogates?
              </td>
            </tr>
            <tr>
              <td>
                Use some discretion – if it is very recent and the names match
                the names given on the order form, then it is not necessary.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What exactly are the necessary documents that need to be on the
                clerks minutes in an lp after a judgment has been filed for us
                to not have to turn it out?
              </td>
            </tr>
            <tr>
              <td>
                Always show a lis pendens that has a judgment of foreclosure
                filed unless the judgment is vacated or it has been 6 years
                since the filing of the judgment.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What is the difference between an open-ended and closed-ended
                mortgage?
              </td>
            </tr>
            <tr>
              <td>
                In an open-ended mortgage you get a checkbook and can
                continuously write checks up to the amount of the mortgage as
                you need the money. You can even pay down the mortgage and then
                write more checks. In a closed-ended mortgage, upon the closing
                you are given the full amount of the mortgage all at one time.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                A City mortgage always seem to have a miniscule amount -
                wouldn’t that be considered an open ended mortgage?
              </td>
            </tr>
            <tr>
              <td>
                The amount of a mortgage has no bearing on whether or not it
                would be considered open-ended.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                On a condominium when the property is sold and no release has
                been recorded do you always have to recite the base lot
                mortgages as open even though the unit has a new mortgage
                recorded against it?
              </td>
            </tr>
            <tr>
              <td>
                Yes, the mortgages on the base lot are still a lien on every
                unit lot unless the unit lot is released from the lien of the
                mortgage.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When doing a reissue and you search a common name can you start
                your name search from the point of the last date. For example if
                the search was done on 6/2006 and the name is Juan Rodriguez do
                you have to do the name full or do you run that name from 6/2006
                to present date?
              </td>
            </tr>
            <tr>
              <td>
                We should always search the name IN FULL so as to pick up all of
                the judgments and liens that currently affect – it’s possible
                that some of the old liens may have been satisfied.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                If a judgment is older than 10 yrs but is on the head, should we
                show it?
              </td>
            </tr>
            <tr>
              <td>
                Check the remarks to see if the judgment is extended or renewed
                – use some discretion, if a few months over 10 years, show it.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When should we stop taking variations of names?
              </td>
            </tr>
            <tr>
              <td>
                Only if it is an extremely common name – and then make a note
                stating how the name was run
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When should a contin be charged as a reissue ?
              </td>
            </tr>
            <tr>
              <td>
                If a contin was requested by the client but you see that the
                title was already closed by the same client then it should be
                billed as a reissue.{' '}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>How do we run a contin ?</td>
            </tr>
            <tr>
              <td>
                Whenever you are doing a contin, it is ALWAYS necessary to
                abstract any new documents found – giving a printout is NOT
                enough. Come from the search “as of” date forward and pick up
                any new liens. In addition, you must check any mortgages or
                liens shown in the original search and see if they have been
                satisfied. Also check the clerk’s minutes for any action to
                determine if there are any new filings. The contin is the last
                chance that we have to pick up something that should have been
                shown in the original search – if you happen to see a judgment
                or lien that is prior to your “as of” date – do a diligent job
                and make sure that the original searcher actually turned it up
                in his search. This helps prevent any possible claim.{' '}
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Some people say that judgments are good for longer than 10 yrs.
                Is this true?
              </td>
            </tr>
            <tr>
              <td>
                Only federal judgments that are indexed in the federal tax lien
                index are good for 20 years.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                How long should we actually check back for C&amp;R’s?
              </td>
            </tr>
            <tr>
              <td>
                C&amp;R’s and easements are good forever. You should check back
                as far as possible –at least 100 years - using whatever indices
                are available in your county. Prior deeds on your parcel should
                be spot-checked for any recitals. Deeds into and out of the
                builder, if any, should always be checked. Keep in mind that
                when there is a builder involved, most C&amp;R’s and easements
                are made between the time when builder buys the property and the
                time when he starts selling off the individual lots.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Some people say that you shouldn’t turn out a really old mtg(
                ex: 1945) if it is not sat. Is this true?
              </td>
            </tr>
            <tr>
              <td>
                Possibly some people feel that the old mortgage is really paid
                off but not satisfied of record. We still must, however, show
                the mortgage as open since it is a cloud on title and must be
                satisfied of record.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                Why is Richmond the only county with DMV’s? Are they really a
                lien at a closing?
              </td>
            </tr>
            <tr>
              <td>
                DMV’s are really a lien with the same effect as any judgment.
                They should be filed in each county in NYC.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                When doing an LSN should we only run Block and Lot in system?{' '}
              </td>
            </tr>
            <tr>
              <td>
                It is only necessary to run the block and lot (and any prior
                lots) in BOTH the computer system and any applicable books that
                may be prior to the system.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                At what point does a mortgage become an “ancient” mortgage?
              </td>
            </tr>
            <tr>
              <td>
                A mortgage in the face amount of not more than $15,000.00 which
                MATURED more than 30 years ago and which has NOT been recited in
                the chain of title for 20 years or more is considered an
                “ancient” mortgage as long as the present owner or an ancestor
                was not the mortgagor. Since affidavits must be signed it is
                necessary for examiners to show ALL open mortgages – it is up to
                the reader to decide if the mortgage can be omitted as an
                “ancient” mortgage.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What is the threshold of deviance from the tax map allowed on a
                metes and bounds description before reference deeds must be
                given?
              </td>
            </tr>
            <tr>
              <td>
                If the variance is ¼ inch or less it is NOT necessary to show
                reference deeds.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>What is an enforcement mortgage ?</td>
            </tr>
            <tr>
              <td>
                An enforcement mortgage is basically a supplement or subsidy to
                the purchase price, usually in low-income housing. It is a
                mortgage given by NYC to the purchaser, in most cases as a
                second mortgage. If certain conditions are met, the mortgage
                need not be re-paid and the mortgage is satisfied.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>What is a “Notice of Lending” ?</td>
            </tr>
            <tr>
              <td>
                A Notice of Lending is a lien filed under Lien Law# 73and is
                filed in conjunction with a mortgage. The Notice of Lending
                should be shown as long as the mortgage is still open of record.
                In the event the mortgage is NOT recorded, then the Notice of
                Lending should be turned out indefinitely.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What is a Severance or Splitter Agreement ?
              </td>
            </tr>
            <tr>
              <td>
                This agreement splits a recorded mortgage into two or more
                liens. This can be accomplished in two ways:
                <br />
                1- The entire remaining indebtedness is reflected in two or more
                substitute mortgages – this replaces the entire back mortgage
                chain, or
                <br />
                2- The remaining indebtedness is reflected in one or more
                substitute mortgages AND the “continuing lien” of the original
                mortgage – the entire back mortgage chain must be abstracted, as
                it is still open
                <br />
                To determine that you are looking at it correctly, make sure
                that the remaining indebtedness equals the substitute mortgages
                combined amounts.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>
                What is a Subordination Agreement ?
              </td>
            </tr>
            <tr>
              <td>
                This agreement changes the priority of lines. It takes an
                existing mortgage and makes it subordinate to a new mortgage or
                consolidation agreement that is about to be recorded. It may
                also make the existing mortgages subordinate to a declaration of
                condo or a land disposition agreement. When abstracting this
                agreement – look for the Document ID of the existing mortgage
                AND the amount of the mortgage that is to be recorded.
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>Surrogate’s Proceeding:</td>
            </tr>
            <tr>
              <td>
                There are different types of proceedings:
                <br />
                <br />
                <ol>
                  <li>
                    Probate – decedent dies testate, WITH a will – executor will
                    be appointed
                  </li>
                  <li>
                    Administration – decedent dies WITHOUT a will –
                    administrator will be appointed
                  </li>
                  <li>
                    Administration CTA – decedent dies WITH a will but no
                    executor qualified – administrator will be appointed
                  </li>
                  <li>
                    Ancillary probate – decedent dies a resident of another
                    jurisdiction and the will was probated in that jurisdiction
                    – there will be an executor appointed in the county where
                    decedent owned real estate for the purpose of selling the
                    property
                  </li>
                </ol>
                ALWAYS include a FULL copy of the will, if any AND of the order
                appointing the executor or administrator – look to see if the
                order in any way restricts the fiduciary from selling or
                encumbering the property – if so, highlight it
                <br />
                <br />
                For court orders to be valid they must be dated and signed by a
                judge.
                <br />
                <br />
                All heirs must waive and consent in a probate proceeding or sign
                a renunciation in an administration proceeding
                <br />
                <br />
                Executors and administrators must sign an oath and designation
                for their appointment to be valid
                <br />
                <br />
                See Surrogate’s proceeding&nbsp;
                <Popover
                  content={
                    <img className={styles.img} src={surrogate} alt="" />
                  }
                >
                  EXHIBIT
                </Popover>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>Foreclosure Proceeding:</td>
            </tr>
            <tr>
              <td>
                Must include copies of ALL affidavits of service and notices of
                appearance
                <br />
                <br />
                Must include copies of the specific allegations in the complaint
                showing why all governmental agencies were made a party
                defendant
                <br />
                <br />
                Include copy of any order to appoint substitute referee
                <br />
                <br />
                Include copy of any assignment of bid
                <br />
                <br />
                Include copy of judgment of foreclosure
                <br />
                <br />
                Make sure the referee appointed in the order of reference is the
                same as the referee in the judgment of foreclosure and the
                referee’s report of sale
                <br />
                <br />
                Any order must be signed and dated to be valid
                <br />
                <br />
                Put your abstract of the foreclosure in the following order:
                <br />
                <br />
                Clerk’s minutes, lis pendens, abstract form, specific
                allegations,affidavits of service and notices of appearance,
                judgment of foreclosure, any other document needed
                <br />
                <br />
                See Foreclosure proceeding &nbsp;
                <Popover
                  content={
                    <img className={styles.img} src={foreclosure} alt="" />
                  }
                >
                  EXHIBIT
                </Popover>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>Condemnation Proceeding:</td>
            </tr>
            <tr>
              <td>
                This is a proceeding where the sovereign (The City of New York)
                acquires title for public use by filing a lis pendens and damage
                map
                <br />
                <br />
                You must include:
                <br />
                <br />
                <ol>
                  <li>The petition to condemn</li>
                  <li>The order of condemnation</li>
                  <li>The damage map showing your parcel</li>
                  <li>
                    The grid from the damage map listing all parcels and their
                    values
                  </li>
                  <li>Clerk’s minutes</li>
                </ol>
                Please note that the damage map will contain a damage parcel
                number, as well as the tax lot number
                <br />
                <br />
                See Condemnation proceeding &nbsp;
                <Popover
                  content={
                    <img className={styles.img} src={condemnation} alt="" />
                  }
                >
                  EXHIBIT
                </Popover>
              </td>
            </tr>
            <tr>
              <td>&nbsp;</td>
            </tr>
            <tr>
              <td className={styles.bold}>How To Perform A Name Run</td>
            </tr>
            <tr>
              <td>
                <b>Objective-</b> Find any returns that could be your parties
                without being overly time consuming and counterproductive so as
                to prevent monetary loss to the company
                <b>Rules-</b>
                <li>
                  If two people take title as husband and wife, you must run the
                  wife with the husband’s last name.
                </li>
                <li>
                  If there is an obvious typo on deed or mortgage, you must run
                  the name that way also.
                </li>
                <li>
                  You must run all names that the person is known as. (any AKA,
                  FKA, NKA)
                </li>
                <li>You must run names as stated on the application.</li>
                <li>
                  When running a hyphenated name, you must split the name.
                </li>
                <br />
                Ex. Mary Tyler-Moore – you would run Mary Tyler and Mary Moore
                <br />
                <br />
                <b>Input- Uncommon Names-</b>
                <br />
                <li>
                  Input NO MORE than four letters of last name and two letters
                  of first name
                </li>
                <li>
                  Do not go past double letters (ex. Mary Sutter Input- Sut, Ma)
                </li>
                <br />
                <br />
                <b>Input- Common Names</b> (ex. Jose Rodriguez)
                <br />
                <li>
                  Input whole name but state “no variations taken” on
                  certification page
                </li>
                <br />
                <br />
                <b>Selection-</b>
                <br />
                <li>Take last name only</li>
                <li>Take all last name with first initial</li>
                <li>
                  Take all nicknames for that name that you can see on the
                  screen
                </li>
                <li>Take exact name</li>
                <li>*ALWAYS disregard middle initial*</li>
                <br />
                <br />
                <b>Examples-</b>
                <br />
                <b>1. Name-</b> Charles Mauro
                <br />
                <b>Input-</b> Maur, Ch
                <br />
                <b>Take-</b> Mauro, C Mauro, Charles Mauro, Charlie Mauro,
                Chucky Mauro, Chuck Mauro, Chuckie Mauro, Chaz Mauro , Chas
                Mauro, etc.
                <br />
                Any of these including middle initial
                <br />
                <br />
                <b>2. Name –</b> Margaret Smith
                <br />
                <b>Input-</b> Smith, Ma
                <br />
                <b>Take-</b> Smith, M Smith, Margie Smith, Margaret Smith, etc.
                <br />
                Any of these including middle initial
                <br />
                DO NOT have to run Peg or Peggy
                <br />
                <br />
                <b>3. Name-</b> I. Brice Moses
                <br />
                <b>Input #1-</b> Mose, I<br />
                <b>Take-</b> Moses, I Moses, Ignatius Moses, Isabel Moses, Izzy
                Moses etc
                <br />
                <b>Input#2-</b> Mose, Br
                <br />
                <b>Take-</b> Moses, Bri Moses, Brice Moses, etc
                <br />
                Any of these including middle initial
                <br />
                <br />
                <b>Input- Corporations</b>
                <br />
                <li>Input as little of the name as possible </li>
                <li>
                  Never type in the suffix of the corporation (Inc., Co., Corp.
                  etc)
                </li>
                <li>
                  If the corporation name is numerical, run with the number AND
                  with the number spelled out (Ex. Sixth Avenue Electronics
                  would be ran as Sixth and 6th)
                </li>
                <b>Selection-</b>
                <li>Take any variation of corporation name</li>
                <br />
                <br />
                <b>Examples-</b>
                <br />
                <b>1. Name-</b> Best Home Properties, LLC <br />
                <b>Input –</b> Best Home Pr
                <br />
                <b>Take-</b> Best Home Properties, Inc. Best Home Properties,
                Best Home Prop, Best Home Prp, Best Home Prop Limited , Etc{' '}
                <br />
                <b>2. Name –</b> First Food Inc.
                <br />
                <b>Input #1–</b> First Fo
                <br />
                <b>Take –</b> First Food LLC, First Food HDCP Inc. , Etc.
                <br />
                <b>Input #2-</b> 1st Fo <br />
                <b>Take –</b> 1st Food Inc., 1st Food LLC, 1st Food, Etc. <br />
                <b>3. Name-</b> The Allied Parking Group
                <br />
                <b>Input #1 –</b> The Allied
                <br />
                <b>Take-</b> The Allied Pkg Grp, The allied Group , etc
                <br />
                <b>Input #2-</b> Allied P<br />
                <b>Take-</b> Allied Parking, Allied Prk Grp
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Typography>
    </Card>
  );
};

export default Faq;
